// 梁
import store from "@/store/index";
import rlModelData from "@/rlMxModules/rlDataClass/rlModelData";
import { getEntityData } from "@/rlMxModules/operate/operateApi";

class rlSubBeamData extends rlModelData {
  getModel3dData = store.state.globalData.rl_wasm_module.getModel3dData;
  // wasm接口方法
  getPKPM_subBeamData =
    store.state.globalData.rl_wasm_module.getPKPM_subBeamData;
  constructor() {
    super();
    this.componentType = "subBeam";
    // 顶点数据
    this.points = [];
    this.deviation = 0;
    // this.Name = null;
    // this.m_sectParamData = {}; //截面源数据
    // this.SectData = []; //截面组合数据
    this.m_gridData1ID = {}; //网格数据1
    this.m_gridData2ID = {}; //网格数据2
    this.m_X1 = null;
    this.m_Y1 = null;
    this.m_Z1 = null;
    this.m_X2 = null;
    this.m_Y2 = null;
    this.m_Z2 = null;

    this.Attribute = 2; //默认为一般构件
    this.classTypeName = "rlSubBeam"; // 梁类型
    this._threeObj = null; //三维图形对象
    this.isSelect = false; //自定义是否选中标识

    this.Color = null;

    this.ModelType = "次梁";
    //this.Layer = "rlBeamSeg"; //图层名称
    // this.LinkGuids = null; //能合并为同一条梁的其他梁的guid
    this.m_groupName = "rlSubBeamGroup"; //组名

    this.isWasmGeted = false; //是否已经获取wasm数据
  }

  initData(obj) {
    super.initData(obj);

    this.m_gridData1ID = obj.m_gridData1ID; //网格数据1
    this.m_gridData2ID = obj.m_gridData2ID; //网格数据2
    this.m_X1 = obj.m_X1;
    this.m_Y1 = obj.m_Y1;
    this.m_Z1 = obj.m_Z1;
    this.m_X2 = obj.m_X2;
    this.m_Y2 = obj.m_Y2;
    this.m_Z2 = obj.m_Z2;

    this.Color = obj.Color;

    this.index2dData = obj.index2dData;
    this.index3dData = obj.index3dData;
    this.points = obj.points;
  }
  //用于撤销回退
  reDraw(obj) {
    super.reDraw(obj);
    this.m_gridData1ID = obj.m_gridData1ID; //网格数据1
    this.m_gridData2ID = obj.m_gridData2ID; //网格数据2
    this.m_X1 = obj.m_X1;
    this.m_Y1 = obj.m_Y1;
    this.m_Z1 = obj.m_Z1;
    this.m_X2 = obj.m_X2;
    this.m_Y2 = obj.m_Y2;
    this.m_Z2 = obj.m_Z2;
  }
  // 数据转换
  convert() {
    if (!this.isWasmGeted || (!this.index2dData && !this.index3dData)) {
      let res = this.getPKPM_subBeamData(
        this.m_sectParamData.Kind,
        this.m_sectParamData.ShapeVal,
        this.m_X1,
        this.m_Y1,
        this.m_Z1,
        this.m_X2,
        this.m_Y2,
        this.m_Z2
        // this.LevelB,
        // this.Height,
      );
      if (!res) return;
      this.getModelDrawData(JSON.parse(res));
      let wasmData = JSON.parse(res);
      let data = `{"${this.Guid}":${JSON.stringify(wasmData)}}`;
      let data3D = this.getModel3dData(data);
      if (!data3D) return;

      data3D = JSON.parse(data3D)["3D"][this.Guid];
      this.points = data3D.Points;
      this.index3dData = {
        points: data3D.Points,
        faces: data3D["3dFaces"].map((item) => item.index).flat(),
      };
    } else {
      this.index2dData = this.index2dData.split(",").map(Number);
    }
    if (this.m_sectParamData.ShapeVal) {
      let splitdata = this.m_sectParamData.ShapeVal.split(",");
      let sectString = splitdata.splice(1, splitdata.length - 3);
      sectString = sectString.join("*");
      this.m_sectGroupName = sectString;
      this.CurrtSect = sectString;
    }
  }

  // wasm截面数据转换
  getModelDrawData(modelData) {
    // this.index3dData = modelData["3D"]["3dFaces"]
    //   .map((item) => item.index)
    //   .flat();
    this.index2dData = modelData["2DUpView"];
    this.SectData = modelData["SectData"];
    this.OtherData = JSON.stringify(modelData);
  }

  // 克隆方法
  myClone() {
    let newObj = new rlSubBeamData();
    super.cloneData(newObj);
    newObj.Color = this.Color;
    newObj.m_gridData1ID = this.m_gridData1ID; //网格数据1
    newObj.m_gridData2ID = this.m_gridData2ID; //网格数据2
    newObj.m_X1 = this.m_X1;
    newObj.m_Y1 = this.m_Y1;
    newObj.m_Z1 = this.m_Z1;
    newObj.m_X2 = this.m_X2;
    newObj.m_Y2 = this.m_Y2;
    newObj.m_Z2 = this.m_Z2;

    return newObj;
  }

  // 绘制
  draw() {
    super.draw();
  }

  // 返回图形源数据
  getDataBase() {
    let data = super.getDataBase();
    data["SectGuid"] = this.m_sectParamData.Guid;

    if (this.m_gridData1ID) data["Grid1Guid"] = this.m_gridData1ID;

    if (this.m_gridData2ID) data["Grid2Guid"] = this.m_gridData2ID;

    data["X1"] = this.m_X1;
    data["Y1"] = this.m_Y1;
    data["Z1"] = this.m_Z1;
    data["X2"] = this.m_X2;
    data["Y2"] = this.m_Y2;
    data["Z2"] = this.m_Z2;

    return data;
  }

  //获取图形绘制数据--用于撤销回退
  getDrawData() {
    let data = super.getDrawData();

    data["m_gridData1ID"] = this.m_gridData1ID;
    data["m_gridData2ID"] = this.m_gridData2ID;
    data["X1"] = this.m_X1;
    data["Y1"] = this.m_Y1;
    data["Z1"] = this.m_Z1;
    data["X2"] = this.m_X2;
    data["Y2"] = this.m_Y2;
    data["Z2"] = this.m_Z2;

    return data;
  }

  // 删除
  async erase() {
    // this.m_JointData ? (this.m_JointData.m_beamId = null) : "";
    await super.erase();
  }
}

export { rlSubBeamData };
